module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-event-item linked-item"
  }, [_c('div', {
    staticClass: "contact-event-icon rdstation-icon"
  }), _c('div', {
    staticClass: "contact-event-header overflow-ellipsis"
  }, [_c('div', {
    staticClass: "contact-event-title"
  }, [_vm._v(_vm._s(_vm.event.title))]), _c('div', {
    staticClass: "right-arrow glyphicon glyphicon-arrow-right"
  }), _c('a', {
    staticClass: "contact-event-description underlined",
    attrs: {
      "href": _vm.event.description,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.event.description))]), _c('div', {
    staticClass: "clear"
  }), _c('div', {
    staticClass: "contact-event-time"
  }, [_vm._v(_vm._s(_vm.event.created_at.format('LLL')))])]), _c('div', {
    staticClass: "clear"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-98611c48!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/events/rd_station_event.vue
// module id = 1194
// module chunks = 1